
const getScript = (params, usingCookiePolicy = false) => {
    const scriptBookingFlow = document.createElement('script');
    const scriptSeekda = document.createElement('script');

    const initCode = `
    var _skd = window._skd || {};
    _skd.tracking = _skd.tracking || {};
    _skd.tracking.tracks = _skd.tracking.tracks || [];
    _skd.widget = _skd.widget || {};
    _skd.widget.trackingApi = _skd.widget.trackingApi || {};
    _skd.widget.trackingApi.isExtendedApi = true;
    _skd.widget.trackingApi.usingCookiePolicy = ${usingCookiePolicy
        || usingCookiePolicy === undefined ? 'true' : 'false'};
    _skd.widget.trackingApi.isCookiePolicyAccepted = ${usingCookiePolicy
        || usingCookiePolicy === undefined ? 'false' : 'true'};
    _skd.widget.trackingApi.isChannel = true;

    // hotelId: propertyCode or channelId
    function onCookiePolicyAccepted(hotelId) {

        _skd.widget.trackingApi.onCookiePolicyAccepted(hotelId);

    } `;
    scriptBookingFlow.id = 'seekda-traking-booking-flow-script';

    scriptBookingFlow.innerHTML = initCode;

    scriptSeekda.id = 'seekda-traking-script';
    scriptSeekda.defer = true;

    const baseUrl = `https://${params.trackingEnvironment === 'development' ? 'cloud-dev' : 'cloud'}.seekda.com`;
    scriptSeekda.src = `${baseUrl}/w/w-tracking-api/group:${params.groupId}/${params.apiToken}.js`;

    return (
        document.body.appendChild(scriptBookingFlow) && document.body.appendChild(scriptSeekda)
    );
};

const pushOnCookiePolicyAcepted = (hotelId, isProduction) => {
    // Set up in the upper code
    const { onCookiePolicyAccepted } = window;
    if (onCookiePolicyAccepted) {
        onCookiePolicyAccepted(hotelId);
        if (!isProduction) {
            // eslint-disable-next-line no-console
            console.log('Pushing on cookie policy accepted for hotel id: ', hotelId);
        }
    }
};

const pushTracking = (type, data) => {
    // Is cloned because seekda modifies the object and otherwise that
    // modified object was sent to the other trackings
    let eventDataCloned = data;
    if (typeof eventDataCloned === 'object') {
        eventDataCloned = Object.assign({}, data);
        // seekda needs propertyId instead of propertyCode
        if (eventDataCloned.propertyCode) {
            eventDataCloned.propertyId = eventDataCloned.propertyCode;
            delete eventDataCloned.propertyCode;
        }
        if (eventDataCloned.searchData && eventDataCloned.priceMode) {
            eventDataCloned.searchData.priceMode = eventDataCloned.priceMode;
            delete eventDataCloned.priceMode;
        }
        if (typeof eventDataCloned.hotelTotal !== 'undefined') {
            eventDataCloned.total = eventDataCloned.hotelTotal;
            delete eventDataCloned.hotelTotal;
        }
        if (typeof eventDataCloned.hotelServicesTotal !== 'undefined') {
            eventDataCloned.servicesTotal = eventDataCloned.hotelServicesTotal;
            delete eventDataCloned.hotelServicesTotal;
        }
        if (typeof eventDataCloned.hotelRoomTotal !== 'undefined') {
            eventDataCloned.roomTotal = eventDataCloned.hotelRoomTotal;
            delete eventDataCloned.hotelRoomTotal;
        }
    }

    _skd.tracking.tracks.push({
        type,
        data : eventDataCloned,
        cb   : (err) => {
            /* eslint-disable no-console */
            if (err !== null) {
                console.error(err);
            } else if (process.env.NODE_ENV === 'development') {
                console.log(`%cseekda ${type}`, 'background: #d4a519; color: white;', eventDataCloned);
            }
            /* eslint-enable no-console */
        },
    });
};

const handlers = { widgetLoaded: eventData => pushTracking('ibe.widgetLoaded', eventData) };

export default { getScript, handlers, pushOnCookiePolicyAcepted };
